export enum ColumnDataType {
	CURRENCY,
	TRANSLATION,
	DEFAULT,
	CHIPS,
	STATUS,
	REGISTERED,
}
